import React, { Component } from 'react'
import Order from './Model/Order'
import ConfirmModal from './jsx/modal/ConfirmModal';
import { Link } from 'react-router-dom'
import TableSessionHelper from "./Model/TableSession";

class CartAndPinFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmModal: null
        }
        this.confirmModalRef = React.createRef()
    }
    isBillingMode() {
        return this.props.mode == 'pay_bill'
    }
    onClick = () => {
        if (this.isBillingMode() && !!Order.getConfirmedOrderTotal()) {
            let me = this
            const isHasPaymentGateway = this.props.app.state.merchant.is_payment_gateway_enabled
            const isPickupTable = this.props.app.state.current_session.pickup
            const isDineInAllowOnlinePayment = this.props.app.isMerchantHasFeature('is_dine_in_allow_online_payment')
            const isAllowOnlinePayment = isHasPaymentGateway && (isPickupTable || isDineInAllowOnlinePayment)
            if (isAllowOnlinePayment) {
                this.setState({
                    confirmModal: <ConfirmModal 
                        ref={this.confirmModalRef}
                        pickup={this.props.app.state.table.pickup}
                        message='Choose your payment method:'
                        buttonLayout="vertical"
                        onClose={() => {
                            this.setState({
                                confirmModal: null
                            })
                        }}
                        onYes={() => {
                            me.props.history.push(`/payment/${me.props.match.params.tableID}`)
                        }}
                        yesText='Pay Online'
                        onNo={() => {
                            me.setState({
                                confirmModal: null
                            }, () => Order.payBill())
                        }}
                        noText='Pay at Counter'
                    />
                })
            }
            else {
                Order.payBill()
            }
        }
    }
    joinTable() {
        let table_session = this.props.app.state.table_session
        if (table_session) {
            this.props.app.setState({
                joiningTable:true
            })
        }
        else {
            // If this table do not has any active session,
            // "Join Table" button will not be shown. So
            // don't have to handle
        }
    }
    showPin() {
        let isNotYetJoinTable = table_session_id == null || this.props.app.state.current_session == null
        let isInBilling = this.props.app.state.current_session != null && this.props.app.state.current_session.bill_id != null
        if (isNotYetJoinTable) {
            if (TableSessionHelper.isNeedToTriggerJoinTable()) {
                return <div id="footer-pin-cart-btn" onClick={this.joinTable.bind(this)} className="pin-footer row">
                    <span className="col-xs-4 footer-text footer-btn">{lang.join_table}</span>
                </div>
            }
        } else if (isInBilling) {
            return <div></div>
        } else {
            if (this.isBillingMode()) {
                if (this.getConfirmedOrders().length > 0 && this.props.app.state.isShowPayBill && !this.props.app.isMerchantHasFeature('hide_pay_bill')) {
                    return (
                    <div id="footer-pin-cart-btn" onClick={this.onClick} className="pin-footer row">
                        <span className="col-xs-4 footer-text footer-btn">{lang.pay_bill_cap} <span className="money-style">{this.props.currencyName}&nbsp; {Order.getConfirmedOrderTotal().toFixed(2)}</span></span>
                    </div>
                    )
                }
                else if (this.props.app.state.isShowPayBill && this.props.app.isMerchantHasFeature('hide_pay_bill')) {
                    return <div id="footer-pin-cart-btn" onClick={() => {}} className="pin-footer row">
                        <span className="col-xs-4 footer-text footer-btn">{lang.bill_total} <span className="money-style">{this.props.currencyName}&nbsp; {Order.getConfirmedOrderTotal().toFixed(2)}</span></span>
                    </div>
                }
                return (
                    <div></div>
                )
            }
            else if (this.isWaitingForPayment()) {
                return <Link to={`/payment/${this.props.tableQR}`}>
                    <div id="footer-pin-cart-btn" onClick={this.onClick} className="pin-footer row">
                        {this.renderPin()}
                        {this.renderButonLabel()}
                        <span className="col-xs-4 footer-text footer-price" >{this.props.currencyName}&nbsp; {Order.getConfirmedOrderTotal().toFixed(2)}</span>
                    </div>
                </Link>
            }
            else if (this.props.app.state.table && this.props.app.state.table.table_type_bitwise == 1) {
                const { table } = this.props.app.state
                let isShowDraftOrderPrice = false
                
                return <Link to={`/order/${this.props.tableQR}`}>
                    <div id="footer-pin-cart-btn" onClick={this.onClick} className="pin-footer row">
                        {this.renderPin()}
                        {this.renderButonLabel()}
                        <span className="col-xs-4 footer-text footer-price">
                            {this.props.currencyName}&nbsp; {Order.getDraftAndConfirmOrderTotal().toFixed(2)}
                        </span>
                        
                    </div>
                </Link>
            }
            else {
                const { table } = this.props.app.state
                let isShowDraftOrderPrice = false
                
                return <Link to={`/pickup/${this.props.tableQR}`}>
                    <div id="footer-pin-cart-btn" onClick={this.onClick} className="pin-footer row">
                        {this.renderPin()}
                        {this.renderButonLabel()}
                        <span className="col-xs-4 footer-text footer-price">
                            {this.props.currencyName}&nbsp; {Order.getDraftAndConfirmOrderTotal().toFixed(2)}
                        </span>
                        
                    </div>
                </Link>
            }
        }
    }
    renderPin() {
        const tablePin = window.hideTablePin ? null : `PIN: ${this.props.app.state.current_session.pin}`
        return this.isBillingMode() ? <span></span> : <span className="col-xs-4 footer-text footer-pin">{tablePin}</span>
    }
    isWaitingForPayment = () => {
        return this.props.app.state.table.pickup && this.props.app.state.current_session.is_pickup_confirmed
    }
    renderButonLabel() {
        let label;
        if (this.isBillingMode()) {
            if (!!Order.getConfirmedOrderTotal() && !this.props.app.isMerchantHasFeature('hide_pay_bill')) {
                label = (lang.pay_bill)
            }
        } 
        else if (this.isWaitingForPayment()) {
            label = <span>{lang.pay_now}</span>
        }
        else {
            let count = this.getDraftOrders().length;
            label = (<span>{lang.view_cart}{(count != 0 && <span className="badge footer-count">{count}</span>)}</span>)
        }
        return <span className="col-xs-4 footer-text footer-btn">{label}</span>
    }
    getDraftOrders() {
        let orders = (this.props.app.state.orders || []).filter((order) => order.order_status == "draft")
        return orders
    }
    getConfirmedOrders() {
        let orders = (this.props.app.state.orders || []).filter((order) => order.order_status == "accepted")
        return orders
    }
    render() {
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }
        if (this.props.location.state && this.props.location.state.hideFooter) {
            return (<div></div>);
        }
        if (this.props.app.state.orders && this.props.app.state.orders.length == 0) {
            return <div></div>
        }

        return <div id="footer-pin-cart">
            {this.state.confirmModal}
            {this.showPin()}
        </div>
    }
}

export default CartAndPinFooter;